<div class="subject cursor-pointer" [class.files-attached]="hasAttachments">
  <span>{{ subject }}</span>
  <i class="icon ic-paperclip-20 cursor-pointer"></i>
</div>
